import { throttle } from '~/rage/decorators';
import { IObservable, Subject } from '~/rage/utils';
import { GreenScreenParamConfig, GreenScreenParams, RgbColor } from '~/shared';
import { GameConfigService } from '../GameConfigService';
import { RpcService } from '../RpcService';
import {
	IGreenScreenService,
	IGreenScreenVehicleModel,
} from './greenScreenServiceTypes';

export class GreenScreenService implements IGreenScreenService {
	private vehicleModels = new Subject<IGreenScreenVehicleModel[]>([]);
	private cameraParams = new Subject<GreenScreenParamConfig[]>([]);

	constructor(
		private readonly rpc: RpcService,
		gameConfig: GameConfigService,
	) {
		gameConfig.getConfigs().subscribe((config) => {
			if (!config) {
				return;
			}

			const vehicleModels =
				config.vehicles?.models?.map(({ name, model }) => ({
					name,
					model,
				})) ?? [];

			this.vehicleModels.next(vehicleModels);

			const nonSliderParams = [
				GreenScreenParams.BodyColor,
				GreenScreenParams.HorizontalAngle,
				GreenScreenParams.SteeringAngle,
			];

			const cameraParams =
				config.greenScreen?.params?.filter(
					(e) => !nonSliderParams.includes(e.type),
				) ?? [];
			this.cameraParams.next(cameraParams);
		});
	}

	public getVehicleModels(): IObservable<IGreenScreenVehicleModel[]> {
		return this.vehicleModels;
	}

	public getCameraParams(): IObservable<GreenScreenParamConfig[]> {
		return this.cameraParams;
	}

	public updateParamValue(
		param: GreenScreenParams,
		value: number | RgbColor,
	): void {
		this.rpc.invokeClient('greenScreen:updateParamValue', {
			param,
			value,
		});
	}

	@throttle(300)
	public swapVehicleModel(model: string): void {
		this.rpc.invokeClient('greenScreen:swapVehicleModel', {
			model,
		});
	}

	public async takeScreenshot(): Promise<void> {
		return this.rpc.invokeClient('greenScreen:takeScreenshot');
	}

	public async exit(): Promise<void> {
		return this.rpc.invokeClient('greenScreen:exit');
	}
}
